import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { PropertyService } from '../../services/property.service';
import { NavigationContextService } from '../../services/navigation-context.service';

@Component({
  selector: 'app-one-property-view',
  templateUrl: './one-property-view.component.html',
  styleUrls: ['./one-property-view.component.scss']
})


export class OnePropertyViewComponent implements OnInit{
  @Input()
   editMode: boolean = false;

   loading: boolean = true;

   @Input()
  attributes;

   property: any;
  activeLease: any = null;
  galleryThumbIndices = [1, 2, 3, 4];
  selectedThumb = 1;

  constructor(
    private route: ActivatedRoute,
    private propertyService: PropertyService,
    public authService: AuthService,
    private router: Router,
    private navContext: NavigationContextService
  ) { }

  ngOnInit(){
     const routeParams = this.route.snapshot.paramMap;
     const propertyId = routeParams.get('id');
     console.log(propertyId);

     if (!propertyId) {
       this.loading = false;
       return;
     }

     this.propertyService.getPublicProperty(propertyId).then((property) => {
        this.property = property;
        this.navContext.setPropertyId(property && property.id);
        console.log(this.property);
        
        // Check for active lease
        this.propertyService.getActiveLease(property).then((lease) => {
          this.activeLease = lease;
        }).catch((error) => {
          console.error('Error loading active lease:', error);
          this.activeLease = null;
        });
        
        // Stop loading immediately - don't wait for image
        // The image will load asynchronously and display when ready
        this.loading = false;
     }).catch((error) => {
        console.error('Error loading property:', error);
        this.loading = false;
        // Set property to null so error state can be shown
        this.property = null;
     });

     this.propertyService.getAttributes().then((attributes) => {
      this.attributes = attributes || [];
    }).catch((error) => {
      console.error('Error loading attributes:', error);
      this.attributes = [];
    });
  }

  getAttributeById(attributeId) {
      if (!this.attributes || !Array.isArray(this.attributes)) {
        return null;
      }
      return this.attributes.find(attribute => {
        return attribute.id == attributeId;
      });
  }

  getImageUrl(path: string) {
    if (!path) {
      return '';
    }
    
    // If it's already a full URL (http/https or data URI), use it directly
    if (path.startsWith('http') || path.startsWith('data:')) {
      // Only convert S3 URLs to API paths if we have a property ID
      if (path.includes('amazonaws.com') && this.property && this.property.id) {
        const fileName = path.substring(path.lastIndexOf('/') + 1);
        return `${environment.apiBaseUrl}/v1/public/properties/${this.property.id}/coverImage/${fileName}`;
      }
      // Otherwise, use the S3 URL directly
      return path;
    }
    
    // If it's a relative path, add the API base URL
    return environment.apiBaseUrl + path;
  }

  onImageLoad() {
    this.loading = false;
  }

  onImageError() {
    this.loading = false;
  }

  close() {
    this.navContext.goToDashboard();
  }

  // Navigation methods for management cards
  viewLeases() {
    if (this.property && this.property.id) {
      this.router.navigate(['manage-leases'], { queryParams: { propertyId: this.property.id } });
    }
  }

  viewInvoices() {
    if (this.property && this.property.id) {
      this.router.navigate(['admin-invoices'], { queryParams: { propertyId: this.property.id } });
    }
  }

  viewExpenses() {
    if (this.property && this.property.id) {
      this.router.navigate(['property-expenses'], { queryParams: { propertyId: this.property.id } });
    }
  }

  recordPayment() {
    if (this.property && this.property.id) {
      this.router.navigate(['external-payment'], { queryParams: { propertyId: this.property.id } });
    }
  }

  editProperty() {
    if (!this.property || !this.property.id) {
      return;
    }
    this.router.navigate(['edit-property', this.property.id]);
  }

  viewStatements() {
    if (this.property && this.property.id) {
      this.router.navigate(['property-statements'], { queryParams: { propertyId: this.property.id } });
    }
  }
}
